import * as Types from './types-hasura.generated';

import { ClientError } from "graphql-request";
export type ArtworkFragment = Pick<Types.Artwork, 'id' | 'name' | 'chainId' | 'description' | 'assetScheme' | 'assetHost' | 'assetPath' | 'assetIPFSPath' | 'metadataScheme' | 'metadataHost' | 'metadataPath' | 'metadataIPFSPath' | 'duration' | 'mimeType' | 'mintTxHash' | 'assetId' | 'assetStatus' | 'tokenId' | 'status' | 'hiddenAt' | 'deletedAt' | 'moderationStatus' | 'moderationFrom' | 'latestTxDate' | 'assetVersion' | 'ownerPublicKey' | 'publicKey' | 'contractAddress' | 'activeSalePriceInETH' | 'lastSalePriceInETH' | 'isIndexed'>;

export type CollectionFragment = Pick<Types.Collection, 'chainId' | 'collectionImageUrl' | 'contractAddress' | 'slug' | 'coverImageUrl' | 'createdAt' | 'creatorAddress' | 'description' | 'id' | 'name' | 'symbol' | 'updatedAt' | 'contractType' | 'moderationStatus' | 'moderationFrom' | 'hiddenAt' | 'deletedAt' | 'baseURI' | 'maxTokenId' | 'isRevealed' | 'brandColor'>;

export type UserFragment = Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>;

export type SocialVerificationFragment = Pick<Types.Social_Verification, 'id' | 'user' | 'createdAt' | 'updatedAt' | 'expiresAt' | 'lastCheckedAt' | 'socialVerificationURL' | 'verificationText' | 'userId' | 'username' | 'isValid' | 'service' | 'failedReason' | 'status'>;

export type AuctionFragment = (
  Pick<Types.Auction, 'auctionId' | 'canceledAt' | 'createdAt' | 'endsAt' | 'finalizedAt' | 'highestBidAmount' | 'highestBidder' | 'id' | 'reservePriceInETH' | 'seller' | 'startsAt' | 'status' | 'tokenId' | 'updatedAt'>
  & { highestBidderUser: Types.Maybe<Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'>> }
);

export type BidFragment = Pick<Types.Bid, 'auctionId' | 'bidAmount' | 'bidder' | 'contractAddress' | 'createdAt' | 'datePlaced' | 'id' | 'seller' | 'status' | 'tokenId' | 'updatedAt'>;

export type LatestArtworkEventFragment = { latestEvents: Array<Pick<Types.Event, 'id' | 'eventType' | 'data'>> };

export type ArtworkEventFragment = Pick<Types.Event, 'id' | 'eventType' | 'data' | 'blockTimestamp' | 'publicKey' | 'tokenId'>;

export type ArtworkMintEventFragment = { mintEvents: Array<Pick<Types.Event, 'id' | 'eventType' | 'data' | 'blockTimestamp' | 'publicKey' | 'tokenId'>> };

export type ArtworkSplitRecipientsFragment = { splitRecipients: { aggregate: Types.Maybe<Pick<Types.Split_Recipient_Aggregate_Fields, 'count'>> } };

export type MostRecentPrivateSaleFragment = { mostRecentPrivateSales: Array<Pick<Types.Private_Sale, 'id' | 'ipfsPath' | 'deadlineAt' | 'soldAt' | 'saleAmountInETH' | 'seller' | 'buyer'>> };

export type MostRecentBuyNowFragment = { buyNows: Array<Pick<Types.Buy_Now, 'id' | 'status' | 'amountInETH' | 'acceptedAt' | 'seller' | 'buyer'>> };

export type MostRecentOfferFragment = { offers: Array<(
    Pick<Types.Offer, 'id' | 'status' | 'amountInETH' | 'acceptedAt' | 'expiresAt' | 'seller' | 'buyer'>
    & { userBuyer: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
  )> };

export type MostRecentAuctionFragment = { auctions: Array<(
    Pick<Types.Auction, 'auctionId' | 'canceledAt' | 'createdAt' | 'duration' | 'endsAt' | 'finalizedAt' | 'highestBidAmount' | 'highestBidder' | 'id' | 'reservePriceInETH' | 'seller' | 'startsAt' | 'status' | 'tokenId' | 'updatedAt'>
    & { highestBidderUser: Types.Maybe<Pick<Types.User, 'publicKey' | 'username' | 'profileImageUrl' | 'coverImageUrl' | 'name'>> }
  )> };

export type ArtworkFragmentExtended = (
  Pick<Types.Artwork, 'chainId' | 'id' | 'name' | 'description' | 'assetScheme' | 'assetHost' | 'assetPath' | 'assetIPFSPath' | 'metadataScheme' | 'metadataHost' | 'metadataPath' | 'metadataIPFSPath' | 'duration' | 'mimeType' | 'mintTxHash' | 'assetId' | 'assetStatus' | 'tokenId' | 'status' | 'hiddenAt' | 'deletedAt' | 'moderationStatus' | 'moderationFrom' | 'latestTxDate' | 'assetVersion' | 'ownerPublicKey' | 'publicKey' | 'contractAddress' | 'activeSalePriceInETH' | 'lastSalePriceInETH' | 'isIndexed'>
  & { owner: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>>, creator: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>>, collection: Types.Maybe<(
    Pick<Types.Collection, 'contractSource' | 'symbol' | 'contractAddress' | 'slug' | 'name' | 'collectionImageUrl' | 'coverImageUrl' | 'contractType' | 'moderationStatus' | 'maxTokenId' | 'isRevealed' | 'chainId' | 'attributes'>
    & { collectionSale: Array<Pick<Types.Collection_Sale, 'mintPrice' | 'saleType' | 'clearingPrice'>> }
  )>, latestEvents: Array<Pick<Types.Event, 'id' | 'eventType' | 'data'>>, mintEvents: Array<Pick<Types.Event, 'id' | 'eventType' | 'data' | 'blockTimestamp' | 'publicKey' | 'tokenId'>>, splitRecipients: { aggregate: Types.Maybe<Pick<Types.Split_Recipient_Aggregate_Fields, 'count'>> }, auctions: Array<(
    Pick<Types.Auction, 'auctionId' | 'canceledAt' | 'createdAt' | 'duration' | 'endsAt' | 'finalizedAt' | 'highestBidAmount' | 'highestBidder' | 'id' | 'reservePriceInETH' | 'seller' | 'startsAt' | 'status' | 'tokenId' | 'updatedAt'>
    & { highestBidderUser: Types.Maybe<Pick<Types.User, 'publicKey' | 'username' | 'profileImageUrl' | 'coverImageUrl' | 'name'>> }
  )>, offers: Array<(
    Pick<Types.Offer, 'id' | 'status' | 'amountInETH' | 'acceptedAt' | 'expiresAt' | 'seller' | 'buyer'>
    & { userBuyer: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
  )>, buyNows: Array<Pick<Types.Buy_Now, 'id' | 'status' | 'amountInETH' | 'acceptedAt' | 'seller' | 'buyer'>>, mostRecentPrivateSales: Array<Pick<Types.Private_Sale, 'id' | 'ipfsPath' | 'deadlineAt' | 'soldAt' | 'saleAmountInETH' | 'seller' | 'buyer'>> }
);

export type SplitsFragment = (
  Pick<Types.Split_Recipient, 'id' | 'contractAddress' | 'indexOfShare' | 'publicKey' | 'sharePercent'>
  & { user: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
);

export type CollectionFragmentExtended = (
  Pick<Types.Collection, 'chainId' | 'collectionImageUrl' | 'contractAddress' | 'slug' | 'coverImageUrl' | 'createdAt' | 'creatorAddress' | 'description' | 'id' | 'name' | 'symbol' | 'updatedAt' | 'contractType' | 'moderationStatus' | 'moderationFrom' | 'hiddenAt' | 'deletedAt' | 'baseURI' | 'maxTokenId' | 'isRevealed' | 'brandColor'>
  & { creator: Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>, splits: Array<(
    Pick<Types.Split_Recipient, 'id' | 'contractAddress' | 'indexOfShare' | 'publicKey' | 'sharePercent'>
    & { user: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
  )> }
);

export type ActivityBidFragment = (
  Pick<Types.Bid, 'auctionId' | 'bidAmount' | 'bidder' | 'contractAddress' | 'createdAt' | 'datePlaced' | 'id' | 'seller' | 'status' | 'tokenId' | 'updatedAt'>
  & { auction: (
    Pick<Types.Auction, 'auctionId' | 'canceledAt' | 'createdAt' | 'endsAt' | 'finalizedAt' | 'highestBidAmount' | 'highestBidder' | 'id' | 'reservePriceInETH' | 'seller' | 'startsAt' | 'status' | 'tokenId' | 'updatedAt'>
    & { highestBidderUser: Types.Maybe<Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'>> }
  ), artwork: Types.Maybe<(
    Pick<Types.Artwork, 'id' | 'name' | 'chainId' | 'description' | 'assetScheme' | 'assetHost' | 'assetPath' | 'assetIPFSPath' | 'metadataScheme' | 'metadataHost' | 'metadataPath' | 'metadataIPFSPath' | 'duration' | 'mimeType' | 'mintTxHash' | 'assetId' | 'assetStatus' | 'tokenId' | 'status' | 'hiddenAt' | 'deletedAt' | 'moderationStatus' | 'moderationFrom' | 'latestTxDate' | 'assetVersion' | 'ownerPublicKey' | 'publicKey' | 'contractAddress' | 'activeSalePriceInETH' | 'lastSalePriceInETH' | 'isIndexed'>
    & { creator: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>>, collection: Types.Maybe<Pick<Types.Collection, 'collectionImageUrl' | 'coverImageUrl' | 'slug'>> }
  )> }
);

export type UserProfileFragment = (
  Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>
  & { twitSocialVerifs: Array<Pick<Types.Social_Verification, 'id' | 'user' | 'createdAt' | 'updatedAt' | 'expiresAt' | 'lastCheckedAt' | 'socialVerificationURL' | 'verificationText' | 'userId' | 'username' | 'isValid' | 'service' | 'failedReason' | 'status'>>, instaSocialVerifs: Array<Pick<Types.Social_Verification, 'id' | 'user' | 'createdAt' | 'updatedAt' | 'expiresAt' | 'lastCheckedAt' | 'socialVerificationURL' | 'verificationText' | 'userId' | 'username' | 'isValid' | 'service' | 'failedReason' | 'status'>>, followerCount: { aggregate: Types.Maybe<Pick<Types.Follow_Aggregate_Fields, 'count'>> }, followingCount: { aggregate: Types.Maybe<Pick<Types.Follow_Aggregate_Fields, 'count'>> } }
);

export type OfferFragment = (
  Pick<Types.Offer, 'amountInETH' | 'status' | 'expiresAt'>
  & { buyer: Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>, artwork: Types.Maybe<(
    Pick<Types.Artwork, 'id' | 'name' | 'chainId' | 'description' | 'assetScheme' | 'assetHost' | 'assetPath' | 'assetIPFSPath' | 'metadataScheme' | 'metadataHost' | 'metadataPath' | 'metadataIPFSPath' | 'duration' | 'mimeType' | 'mintTxHash' | 'assetId' | 'assetStatus' | 'tokenId' | 'status' | 'hiddenAt' | 'deletedAt' | 'moderationStatus' | 'moderationFrom' | 'latestTxDate' | 'assetVersion' | 'ownerPublicKey' | 'publicKey' | 'contractAddress' | 'activeSalePriceInETH' | 'lastSalePriceInETH' | 'isIndexed'>
    & { creator: Types.Maybe<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>>, collection: Types.Maybe<Pick<Types.Collection, 'collectionImageUrl' | 'coverImageUrl' | 'slug'>> }
  )> }
);

export type AssetFragment = Pick<Types.Asset, 'id' | 'publicUrl' | 'quality' | 'contractAddress' | 'tokenId' | 'mimeType'>;


export const ArtworkFragment = /*#__PURE__*/ `
    fragment ArtworkFragment on artwork {
  id
  name
  chainId
  description
  assetScheme
  assetHost
  assetPath
  assetIPFSPath
  metadataScheme
  metadataHost
  metadataPath
  metadataIPFSPath
  duration
  mimeType
  mintTxHash
  assetId
  assetStatus
  tokenId
  status
  hiddenAt
  deletedAt
  moderationStatus
  moderationFrom
  latestTxDate
  assetVersion
  ownerPublicKey
  publicKey
  contractAddress
  activeSalePriceInETH
  lastSalePriceInETH
  isIndexed
}
    `;
export const LatestArtworkEventFragment = /*#__PURE__*/ `
    fragment LatestArtworkEventFragment on artwork {
  latestEvents: event(
    where: {eventType: {_nin: ["MIGRATE_CREATOR", "MIGRATE_CREATOR_PAYMENT_ADDRESS", "MIGRATE_OWNER", "MIGRATE_SELLER", "SELL", "PRICE_CHANGE"]}}
    limit: 1
    order_by: {blockTimestamp: desc_nulls_last}
  ) {
    id
    eventType
    data
  }
}
    `;
export const ArtworkEventFragment = /*#__PURE__*/ `
    fragment ArtworkEventFragment on event {
  id
  eventType
  data
  blockTimestamp
  publicKey
  tokenId
}
    `;
export const ArtworkMintEventFragment = /*#__PURE__*/ `
    fragment ArtworkMintEventFragment on artwork {
  mintEvents: event(where: {eventType: {_eq: "MINT"}}, limit: 1) {
    ...ArtworkEventFragment
  }
}
    ${ArtworkEventFragment}`;
export const ArtworkSplitRecipientsFragment = /*#__PURE__*/ `
    fragment ArtworkSplitRecipientsFragment on artwork {
  splitRecipients: splitRecipients_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const MostRecentAuctionFragment = /*#__PURE__*/ `
    fragment MostRecentAuctionFragment on artwork {
  auctions(
    where: {status: {_in: ["OPEN", "FINALIZED", "ENDED"]}}
    order_by: {endsAt: desc_nulls_first}
    limit: 5
  ) {
    auctionId
    canceledAt
    createdAt
    duration
    endsAt
    finalizedAt
    highestBidAmount
    highestBidder
    id
    reservePriceInETH
    seller
    startsAt
    status
    tokenId
    updatedAt
    highestBidderUser {
      publicKey
      username
      profileImageUrl
      coverImageUrl
      name
    }
  }
}
    `;
export const MostRecentOfferFragment = /*#__PURE__*/ `
    fragment MostRecentOfferFragment on artwork {
  offers(
    where: {status: {_in: ["ACCEPTED", "HIGHEST"]}}
    order_by: {placedAt: desc}
    limit: 5
  ) {
    id
    status
    amountInETH
    acceptedAt
    expiresAt
    seller
    buyer
    userBuyer {
      name
      profileImageUrl
      publicKey
      username
    }
  }
}
    `;
export const MostRecentBuyNowFragment = /*#__PURE__*/ `
    fragment MostRecentBuyNowFragment on artwork {
  buyNows(
    where: {status: {_in: ["ACCEPTED", "OPEN"]}}
    order_by: {createdAt: desc}
    limit: 5
  ) {
    id
    status
    amountInETH
    acceptedAt
    seller
    buyer
  }
}
    `;
export const MostRecentPrivateSaleFragment = /*#__PURE__*/ `
    fragment MostRecentPrivateSaleFragment on artwork {
  mostRecentPrivateSales: privateSales(
    where: {soldAt: {_is_null: false}}
    limit: 1
  ) {
    id
    ipfsPath
    deadlineAt
    soldAt
    saleAmountInETH
    seller
    buyer
  }
}
    `;
export const UserFragment = /*#__PURE__*/ `
    fragment UserFragment on user {
  bio
  coverImageUrl
  createdAt
  isAdmin
  links
  moderationStatus
  name
  profileImageUrl
  publicKey
  username
}
    `;
export const ArtworkFragmentExtended = /*#__PURE__*/ `
    fragment ArtworkFragmentExtended on artwork {
  ...ArtworkFragment
  ...LatestArtworkEventFragment
  ...ArtworkMintEventFragment
  ...ArtworkSplitRecipientsFragment
  ...MostRecentAuctionFragment
  ...MostRecentOfferFragment
  ...MostRecentBuyNowFragment
  ...MostRecentPrivateSaleFragment
  chainId
  owner {
    ...UserFragment
  }
  creator: user {
    ...UserFragment
  }
  collection {
    contractSource
    symbol
    contractAddress
    slug
    name
    collectionImageUrl
    coverImageUrl
    contractType
    moderationStatus
    maxTokenId
    isRevealed
    chainId
    collectionSale: collection_sales(limit: 1) {
      mintPrice
      saleType
      clearingPrice
    }
    attributes
  }
}
    ${ArtworkFragment}
${LatestArtworkEventFragment}
${ArtworkMintEventFragment}
${ArtworkSplitRecipientsFragment}
${MostRecentAuctionFragment}
${MostRecentOfferFragment}
${MostRecentBuyNowFragment}
${MostRecentPrivateSaleFragment}
${UserFragment}`;
export const CollectionFragment = /*#__PURE__*/ `
    fragment CollectionFragment on collection {
  chainId
  collectionImageUrl
  contractAddress
  slug
  coverImageUrl
  createdAt
  creatorAddress
  description
  id
  name
  symbol
  updatedAt
  contractType
  moderationStatus
  moderationFrom
  hiddenAt
  deletedAt
  baseURI
  maxTokenId
  isRevealed
  brandColor
}
    `;
export const SplitsFragment = /*#__PURE__*/ `
    fragment SplitsFragment on split_recipient {
  id
  contractAddress
  indexOfShare
  publicKey
  sharePercent
  user {
    name
    profileImageUrl
    publicKey
    username
  }
}
    `;
export const CollectionFragmentExtended = /*#__PURE__*/ `
    fragment CollectionFragmentExtended on collection {
  ...CollectionFragment
  creator: user {
    ...UserFragment
  }
  splits: splitRecipients {
    ...SplitsFragment
  }
}
    ${CollectionFragment}
${UserFragment}
${SplitsFragment}`;
export const BidFragment = /*#__PURE__*/ `
    fragment BidFragment on bid {
  auctionId
  bidAmount
  bidder
  contractAddress
  createdAt
  datePlaced
  id
  seller
  status
  tokenId
  updatedAt
}
    `;
export const AuctionFragment = /*#__PURE__*/ `
    fragment AuctionFragment on auction {
  auctionId
  canceledAt
  createdAt
  endsAt
  finalizedAt
  highestBidAmount
  highestBidder
  id
  reservePriceInETH
  seller
  startsAt
  status
  tokenId
  updatedAt
  highestBidderUser {
    name
    profileImageUrl
    publicKey
    username
  }
}
    `;
export const ActivityBidFragment = /*#__PURE__*/ `
    fragment ActivityBidFragment on bid {
  ...BidFragment
  auction {
    ...AuctionFragment
  }
  artwork {
    ...ArtworkFragment
    creator: user {
      ...UserFragment
    }
    collection {
      collectionImageUrl
      coverImageUrl
      slug
    }
  }
}
    ${BidFragment}
${AuctionFragment}
${ArtworkFragment}
${UserFragment}`;
export const SocialVerificationFragment = /*#__PURE__*/ `
    fragment SocialVerificationFragment on social_verification {
  id
  user
  createdAt
  updatedAt
  expiresAt
  lastCheckedAt
  socialVerificationURL
  verificationText
  userId
  username
  isValid
  service
  failedReason
  status
}
    `;
export const UserProfileFragment = /*#__PURE__*/ `
    fragment UserProfileFragment on user {
  ...UserFragment
  twitSocialVerifs: socialVerifications(
    where: {isValid: {_eq: true}, service: {_eq: "TWITTER"}}
    limit: 1
  ) {
    ...SocialVerificationFragment
  }
  instaSocialVerifs: socialVerifications(
    where: {isValid: {_eq: true}, service: {_eq: "INSTAGRAM"}}
    limit: 1
  ) {
    ...SocialVerificationFragment
  }
  followerCount: follows_aggregate(where: {isFollowing: {_eq: true}}) {
    aggregate {
      count
    }
  }
  followingCount: following_aggregate(where: {isFollowing: {_eq: true}}) {
    aggregate {
      count
    }
  }
}
    ${UserFragment}
${SocialVerificationFragment}`;
export const OfferFragment = /*#__PURE__*/ `
    fragment OfferFragment on offer {
  amountInETH
  status
  expiresAt
  buyer: userBuyer {
    ...UserFragment
  }
  artwork {
    ...ArtworkFragment
    creator: user {
      ...UserFragment
    }
    collection {
      collectionImageUrl
      coverImageUrl
      slug
    }
  }
}
    ${UserFragment}
${ArtworkFragment}`;
export const AssetFragment = /*#__PURE__*/ `
    fragment AssetFragment on asset {
  id
  publicUrl
  quality
  contractAddress
  tokenId
  mimeType
}
    `;